<template>
  <div class="tip">
    <div class="message">
      {{label}}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.tip {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  height: 100vh;
  justify-content: center;
  .message {
    background:rgba(0,0,0,0.8);
    border-radius:6px;
    padding: 10px 18px;
    font-size:14px;
    font-family:AlibabaPuHuiTi-Regular,AlibabaPuHuiTi;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:20px;
  }
}
</style>
